export const LAST_SEEN_KEY = "adminPaymentFailureLastSeen";

export const isPaymentFailed = (order) => order?.status === "payment failed";

export const filterPaymentFailures = (orders) =>
  (orders || []).filter(isPaymentFailed);

export const getNewFailures = (failures) => {
  const lastSeen = localStorage.getItem(LAST_SEEN_KEY);
  return failures.filter(
    (o) => new Date(o.completedOn) > new Date(lastSeen || 0)
  );
};

export const markPaymentFailuresAsSeen = () => {
  localStorage.setItem(LAST_SEEN_KEY, new Date().toISOString());
};

export const sortByCompletedOnDesc = (orders) =>
  [...orders].sort(
    (a, b) => new Date(b.completedOn) - new Date(a.completedOn)
  );

export const formatOrderStatus = (status) => {
  if (status === "payment failed") return "Payment Failed";
  return status
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
